export const dateFormat = 'L' // Localized format, sample output: 08/16/2018

export const fullDateFormat = 'LL' // Localized format, sample output: 	August 16, 2018

export const shortDateFormat = 'll' // Localized format, sample output: Aug 16, 2018

export const yearMonthDateFormat = 'YYYY-MM-DD' // non-localized format, sample output: 2018-08-16

export const dateTimeFormat = 'MMMM DD, h:mm A' // Non-localized format, sample output: August 16, 8:02 PM

export const dayFormat = 'dddd' // Day format, sample output: Monday
